import { createActions } from "reduxsauce";

export default createActions(
  {
    initialDiagnosticFetched: ["diagnostic"],
    painZonesFetched: ["front", "left", "back", "right"],
    currentQuestionChanged: ["questionId"],
    moveToPreviousQuestion: null,
    moveToNextQuestion: null,
    displayHelp: null,
    setChangeAnswerConfirmed: ["changeAnswerConfirmed"],
    onChangeAnswer: null,
    setAnswerGlow: ["answerGlowing"],
    setMovingNext: ["movingNext"],
    setAnimationState: [
      "animationState",
      "animationDirection",
      "animationAction",
      "questionId"
    ],
    jumpToQuestion: ["questionId"],
    onDiagnosticExit: null,
    consentMedical: null,
    consentTerms: null,
    consentPrivacy: null
  },
  { prefix: "diagnostic/" }
);



// WEBPACK FOOTER //
// ./src/modules/diagnostic/diagnostic-actions.js